import { Fragment, useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import data from "../appointments.json";
import BookAppointment from "../components/Appointments/BookAppointment";
import DigitalHealthFAB from "../components/Digitalhealth";

const BookAppointmentPage = () => {
  const [searchParams] = useSearchParams();
  const autoOpenRef = useRef(null); // BookAppointment exposes its open trigger here
 
  useEffect(() => {
    if (searchParams.get("openModal") === "true") {
      // Small delay to ensure BookAppointment has mounted and registered the ref
      const timer = setTimeout(() => {
        autoOpenRef.current?.();
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [searchParams]);

  return (
    <Fragment>
      <DigitalHealthFAB/>
       <BookAppointment data={data.bookAppointment} autoOpenRef={autoOpenRef} />
    </Fragment>
  );
};

export default BookAppointmentPage;